import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { LanguageServiceService } from '../../services/language-service.service';
import { LanguagesService } from '../../services/languages.service';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoginService } from '../../components/Authentication/auth/login.service';
import { LogoutService } from '../../components/Authentication/auth/logout.service';

import { UserService } from '../../services/user';
import { PetsService } from '../../services/pets';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-notuserheader',
  templateUrl: './notuserheader.component.html',
  styleUrl: './notuserheader.component.scss'
})
export class NotuserheaderComponent implements OnInit {

  currentLanguage!: string | null;
  languageDropdownOpen = false;
  contentReady: boolean = true;
  lang = [
    { code: 'en', name: 'English' },
    { code: 'ar', name: 'Arabic' },
    { code: 'fr', name: 'French' },
  ];

  constructor(
    private transloco: TranslocoService,
    private _languageService: LanguageServiceService,
    private _userService: UserService,
  ) {
    const savedLang = localStorage.getItem('language') || 'en';
    this.currentLanguage = savedLang;
    this.transloco.setActiveLang(this.currentLanguage);
  }
  toggleLanguage() {
    this._languageService.toggleLanguage();
    this.currentLanguage = localStorage.getItem('language') || 'en';
    this.transloco.setActiveLang(this.currentLanguage);
  }

  toggleLanguageDropdown(event?: Event): void {
    event?.stopPropagation();
    this.languageDropdownOpen = !this.languageDropdownOpen;
  }

  setLanguage(language: string, event?: Event): void {
    event?.stopPropagation();
    this._languageService.changeLanguage(language);
    this.currentLanguage = language;
    this.transloco.setActiveLang(language);
    this.languageDropdownOpen = false;
  }

  ngOnInit(): void {
    this._languageService.currentLanguage$.subscribe((language) => {
      this.currentLanguage = language;
    });

  }
}
